import { optionsToStrategy } from '@/common/utils/optionsToStrategy'

export const unitForConsumptionOptions = [
  { label: 'Quilômetros', value: 'kilometers' },
  { label: 'Horas uso', value: 'hours' },
]

export const unitForConsumptionStrategy = optionsToStrategy(unitForConsumptionOptions)
